import { styled } from '@openeducation/oe-rn-themes';
import React, { memo } from 'react';
import { TextInput, TextInputProps } from 'react-native-paper';

import { TestId } from '../../constants/test-id';

export type OETextInputProps = Partial<TextInputProps> & {
  onChangeText: (value: string, name?: string) => void;
  autoComplete?: string;
  name?: string;
  secure?: boolean;
};

export const OETextInput = ({
  onChangeText,
  autoComplete = 'off',
  name,
  secure,
  testID = TestId.TEXT_INPUT,
  ...props
}: OETextInputProps) => {
  return (
    <StyledTextInput
      testID={testID}
      onChangeText={(text) => onChangeText(text, name)}
      secureTextEntry={secure}
      mode="outlined"
      autoComplete={autoComplete}
      {...props}
    />
  );
};

const StyledTextInput = styled(TextInput)`
  border-color: ${({ theme }) => theme.color.black};
  background-color: ${({ theme }) => theme.color.white};
  border-style: solid;
` as unknown as typeof TextInput;

export default memo(OETextInput);
